import { render, staticRenderFns } from "./left-select.vue?vue&type=template&id=628b9ea2&scoped=true"
import script from "./left-select.vue?vue&type=script&lang=js"
export * from "./left-select.vue?vue&type=script&lang=js"
import style0 from "./left-select.vue?vue&type=style&index=0&id=628b9ea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628b9ea2",
  null
  
)

export default component.exports